import React from 'react';
import './ContentHeader.scss';

const ContentHeader = ({ title, date }) => (
  <header className={'ContentHeader'}>
    <div className="inner-wrapper">
      {date && <time itemProp="datePublished">{date}</time>}
      <h1 itemProp="headline">{title}</h1>
    </div>
  </header>
);

export default ContentHeader;
